import Loadable from "@loadable/component";

const PaymentError = Loadable(
  () => import(/* webpackChunkName: "payment_error_page" */ "./PaymentError")
);

export default PaymentError;
